import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import Employees from 'pages/extra-pages/Employees';
import EmployeeDetails from 'pages/extra-pages/EmployeeDetails';
import EmployeeDashboard from 'pages/extra-pages/EmployeeDashboard';
import SubStores from 'pages/extra-pages/SubStores';
import SubstoreDetails from 'pages/extra-pages/SubstoreDetails';
import Profile from 'pages/extra-pages/Profile';
import ProtectedRoute from 'components/ProtectedRoute';
import ManageSubscription from 'pages/extra-pages/ManageSubscription';
import About from 'pages/extra-pages/About';
import Privacy from 'pages/extra-pages/Privacy';
import Terms from 'pages/extra-pages/Terms';

// render- Dashboard
const ShiftsTemplate = Loadable(lazy(() => import('pages/Shifts')));
const ShiftsDashboard = Loadable(lazy(() => import('pages/dashboard/shifts')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (  
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <ShiftsDashboard />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'shifts',
          element: <ShiftsDashboard />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'employees',
      element: <Employees />
    },
    {
      path: 'employee-dashboard',
      element: <EmployeeDashboard />
    },
    {
      path: 'employee/:employeeId',
      element: <EmployeeDetails />
    },
    {
      path: 'substores',
      element: <SubStores />
    },
    {
      path: 'substore/:substoreId',
      element: <SubstoreDetails />
    },
    {
      path: 'profile',
      element: <Profile />
    },
    {
      path: 'subscription',
      element: <ManageSubscription />
    },
    {
      path: 'about',
      element: <About />
    },
    {
      path: 'privacy',
      element: <Privacy />
    },
    {
      path: 'terms',
      element: <Terms />
    },
    {
      path: 'shifts-template',
      element: <ShiftsTemplate />
    }
  ]
};

export default MainRoutes;
